import { ILineItemsData } from '@common/interfaces/Common';
import { IProviderLineItem } from '@common/interfaces';

const getData = (data: IProviderLineItem | undefined): ILineItemsData[] => {
  if (data) {
    const rows = Object.keys(data).map((row) => {
      const keys = Object.keys(data[row]);
      // @ts-ignore
      const result: ILineItemsData = keys.reduce((aggregator: ILineItemsData, key: string) => {
        if (key === 'line_item_order_number') {
          return { ...aggregator, order: data[row][key] };
        }

        return {
          ...aggregator,
          uuid: {
            ...aggregator.uuid,
            [key]: data[row][key]?.line_item_quotation?.uuid || null,
          },
          details: {
            ...aggregator.details,
            [key]: data[row][key]?.line_item_quotation || null,
          },
          values: {
            ...aggregator.values,
            [key]: data[row][key]?.quote || null,
          },
          destination: {
            name: data[row].line_item_destination.name,
            uuid: data[row].line_item_destination.uuid,
          },
        };
      }, {} as ILineItemsData);
      return result;
    });
    return rows;
  }
  return [];
};

export default getData;
